export default "__VITE_ASSET__DXK_FJZf__"